import React, { useState, useEffect } from "react";
import styled from "styled-components";
import addToMailchimp from "gatsby-plugin-mailchimp";
import { Link } from "gatsby";

const MailchimpFormContainer = styled.div`
  position: relative;
  width: 100%;

  & .mailchimp-signup-form {
    width: 100%;
  }

  & input {
    ::-webkit-input-placeholder {
      font-family: "Times New Roman", "Times", TimesNewRoman, Times New Roman,
        Times, Baskerville, Georgia, serif;

      font-size: 16px;
      line-height: 125%;
      color: #6f6d6d;
    }
    ::-moz-placeholder {
      font-family: "Times New Roman", "Times", TimesNewRoman, Times New Roman,
        Times, Baskerville, Georgia, serif;

      font-size: 16px;
      line-height: 125%;
      color: #6f6d6d;
    }
    :-ms-input-placeholder {
      font-family: "Times New Roman", "Times", TimesNewRoman, Times New Roman,
        Times, Baskerville, Georgia, serif;

      font-size: 16px;
      line-height: 125%;
      color: #6f6d6d;
    }
    :-moz-placeholder {
      font-family: "Times New Roman", "Times", TimesNewRoman, Times New Roman,
        Times, Baskerville, Georgia, serif;

      font-size: 16px;
      line-height: 125%;
      color: #6f6d6d;
    }
    ::placeholder {
      font-family: "Times New Roman", "Times", TimesNewRoman, Times New Roman,
        Times, Baskerville, Georgia, serif;

      font-size: 16px;
      line-height: 125%;
      color: #6f6d6d;
    }
  }
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  & .field-group {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  & label {
    font-size: 14px;
    line-height: 125%;
    margin: 0 0 4px 0;
  }

  & input {
    width: 100%;
    font-size: 16px;
    line-height: 125%;
    padding: 2px 0 4px 0;
    margin: 0;
    background-color: transparent;
    -webkit-appearance: none;
    appearance: none;
    border: 0;
    border-bottom: 1px solid #000;
    color: #000;

    &:focus {
      outline: none;
    }

    &::placeholder {
      color: #6d6d6d;
    }
  }
`;

const ThankYouMessage = styled.div`
  font-size: 16px;
  line-height: 125%;

  & p {
    margin: 0 0 10px 0;
  }
`;

const SignUpButton = styled.button`
  font-size: 16px;
  line-height: 125%;

  -webkit-appearance: none;
  appearance: none;

  border: 0;
  margin: 0 0 0 auto;

  position: relative;

  cursor: pointer;
  color: #6f6d6d;

  &:focus {
    outline: none;
  }

  border: 0;
  padding: 7px;

  transition: 150ms color ease;

  &:hover {
    color: #000;
  }
`;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  margin-top: 20px;
`;

const GDPRContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  column-gap: 10px;

  @media (max-width: 375px) {
    margin-bottom: 20px;
  }

  & .gdpr-checkbox {
    width: 16px;
    height: 16px;
    position: relative;
    margin-top: 3px;
  }

  & .gdpr-checkbox input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin: 0;
    padding: 0;
    visibility: hidden;
    position: absolute;
  }

  & .gdpr-checkbox label {
    width: 14px;
    height: 14px;
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #000;
    display: block;
  }

  & .gdpr-checkbox input[type="checkbox"]:checked + label {
    background-color: transparent;
  }

  & .gdpr-checkbox input[type="checkbox"]:checked + label:before {
    content: "";
    position: absolute;
    background-color: #000;
    width: 1px;
    height: 10px;
    top: 2px;
    left: 6.5px;
    transform: rotate(45deg);
  }

  & .gdpr-checkbox input[type="checkbox"]:checked + label:after {
    content: "";
    position: absolute;
    background-color: #000;
    width: 1px;
    height: 10px;
    top: 2px;
    left: 6.5px;
    transform: rotate(-45deg);
  }

  & p {
    margin: 0;
    & a {
      transition: 150ms color ease;

      &:hover {
        color: #6f6d6d;
      }
    }
  }
`;

export const MailchimpPopupForm = ({ onSuccess }) => {
  const [mailchimpMessage, setMailchimpMessage] = useState(null);
  const [mailchimpErrorMessage, setMailchimpErrorMessage] = useState(false);
  const [isGDPRChecked, setIsGDPRChecked] = useState(true);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [formMessage, setFormMessage] = useState(null);

  const handleSubmit = e => {
    e.preventDefault();
    console.log("Form submitted", {
      email,
      firstName,
      lastName,
      isGDPRChecked,
    });

    if (!isGDPRChecked) {
      console.log("GDPR not checked");
      return;
    }

    if (!email) {
      console.log("Email is required");
      return;
    }

    console.log("Calling addToMailchimp...");
    addToMailchimp(email, {
      FNAME: firstName,
      LNAME: lastName,
    })
      .then(data => {
        console.log("Mailchimp response:", data);
        if (data.result === "error") {
          if (data.msg === "The email you entered is not valid.") {
            setFormMessage("Invalid E-mail");
          }

          if (data.msg.includes("already subscribed")) {
            setFormMessage(`E-mail is already subscribed`);
          }
        } else {
          setMailchimpMessage(
            "Thank you for signing up to the ADZ Gallery mailing list."
          );
          setFirstName("");
          setLastName("");
          setEmail("");
          setFormMessage(null);
          e.target.reset();
        }
      })
      .catch(error => {
        console.error("Mailchimp error:", error);
      });
  };

  useEffect(() => {
    if (mailchimpMessage !== null) {
      // Show thank you message for 2 seconds, then close popup
      const closePopup = setTimeout(() => {
        if (onSuccess) {
          onSuccess();
        }
      }, 2000);
      return () => clearTimeout(closePopup);
    }
  }, [mailchimpMessage, onSuccess]);

  return (
    <MailchimpFormContainer>
      <form onSubmit={e => handleSubmit(e)} className="mailchimp-signup-form">
        {mailchimpMessage === null ? (
          <>
            <InputContainer>
              <div className="field-group">
                <input
                  id="popup-first-name"
                  type="text"
                  name="first-name"
                  autoComplete="given-name"
                  value={firstName}
                  placeholder="First name"
                  onChange={e => setFirstName(e.target.value)}
                />
              </div>
              <div className="field-group">
                <input
                  id="popup-last-name"
                  type="text"
                  name="last-name"
                  autoComplete="family-name"
                  value={lastName}
                  placeholder="Last name"
                  onChange={e => setLastName(e.target.value)}
                />
              </div>
              <div className="field-group">
                <input
                  id="popup-email"
                  type="email"
                  name="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder={formMessage !== null ? formMessage : "Email"}
                />
              </div>
            </InputContainer>

            <FooterContainer>
              <GDPRContainer className="gdpr-container">
                <div className="gdpr-checkbox">
                  <input
                    type="checkbox"
                    id="popup-gdpr-checkbox"
                    name="gdpr-checkbox"
                    checked={isGDPRChecked}
                    onChange={() => setIsGDPRChecked(!isGDPRChecked)}
                    required
                  />
                  <label htmlFor="popup-gdpr-checkbox"></label>
                </div>

                <p>
                  I accept the{" "}
                  <Link to={`/privacy-policy`}>cookie & privacy policy</Link>
                </p>
              </GDPRContainer>

              <SignUpButton type="submit">Send</SignUpButton>
            </FooterContainer>
          </>
        ) : (
          <ThankYouMessage>{mailchimpMessage}</ThankYouMessage>
        )}
      </form>
    </MailchimpFormContainer>
  );
};
